import { faker } from '@faker-js/faker';
import { BrancheEnum, GenderEnum, TagadaCandidateStatusEnum, TagadaAvisStatusEnum, } from '@sgdf/client';
export const createUser = (params) => {
    return Object.assign({ id: faker.string.uuid(), email: faker.internet.email(), first_name: faker.person.firstName(), last_name: faker.person.lastName(), usage_first_name: faker.person.firstName(), usage_last_name: faker.person.lastName(), birth_name: faker.person.lastName(), phone: faker.phone.number(), gender: faker.helpers.arrayElement(['2', '1']), birthdate: faker.date.past(), fonction_code: '210', fonction: "RESPONSABLE D'UNITE LOUVETEAU JEANNETTE", structure: 'GROUPE ST GEORGES', username: '151111111', diplomas: [], last_sync: faker.date.past() }, params);
};
export const createSGDFUser = (params) => {
    const { email, username, phone, first_name, last_name, usage_first_name, usage_last_name, birthdate, gender, fonction, fonction_code, diplomas, last_sync, } = createUser(params);
    return {
        id: '12345',
        email,
        username,
        adherent_id: username,
        phone,
        first_name,
        last_name,
        usage_first_name,
        usage_last_name,
        birthdate,
        is_superuser: false,
        gender,
        fonction,
        fonction_code,
        structure: 'GROUPE ST GEORGES',
        participations: [],
        diplomas,
        last_sync,
        is_deontologie_validated: false,
        avatar_url: 'https://null.dev',
        avatar_available: false,
        document_signature_url: 'https://null.dev',
        document_signature_available: false,
    };
};
export const createNotNestedMeetingParticipant = () => {
    const url = 'https://xsgames.co/randomusers/avatar.php?g=female';
    return {
        id: faker.string.uuid(),
        user_id: faker.string.uuid(),
        first_name: faker.person.firstName(),
        last_name: faker.person.lastName(),
        usage_first_name: faker.person.firstName(),
        usage_last_name: faker.person.lastName(),
        teams: [faker.lorem.word(), faker.lorem.word()],
        avatar_url: url,
        avatar_available: true,
        user_avatar_url: url,
        user_avatar_available: true,
    };
};
export const createMeetingParticipant = (params, userOverride) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const user = createUser(Object.assign(Object.assign({}, userOverride), { first_name: (_a = userOverride === null || userOverride === void 0 ? void 0 : userOverride.first_name) !== null && _a !== void 0 ? _a : params === null || params === void 0 ? void 0 : params.first_name, last_name: (_b = userOverride === null || userOverride === void 0 ? void 0 : userOverride.last_name) !== null && _b !== void 0 ? _b : params === null || params === void 0 ? void 0 : params.last_name }));
    return Object.assign({ id: faker.string.uuid(), first_name: (_c = user.first_name) !== null && _c !== void 0 ? _c : faker.person.firstName(), last_name: (_d = user.last_name) !== null && _d !== void 0 ? _d : faker.person.lastName(), usage_first_name: (_e = user.first_name) !== null && _e !== void 0 ? _e : faker.person.firstName(), usage_last_name: (_f = user.last_name) !== null && _f !== void 0 ? _f : faker.person.lastName(), birth_name: faker.person.lastName(), role: {
            id: faker.string.uuid(),
            intranet_id: faker.helpers.arrayElement([1, 2, 3]),
            role: faker.lorem.word(),
        }, which_administrative_firstname: 'first_name', which_administrative_lastname: 'last_name', user: user, user_id: user.id, birthdate: faker.date.past(), created: faker.date.past(), updated: faker.date.past(), last_sync: faker.date.past(), user_last_sync: faker.date.past(), meeting: faker.string.uuid(), track_id: faker.string.uuid(), track: {
            id: faker.string.uuid(),
            label: faker.lorem.word(),
            meeting: faker.string.uuid(),
        }, daily_task_team: {
            id: faker.string.uuid(),
            label: faker.lorem.word(),
            meeting: faker.string.uuid(),
            color: faker.internet.color(),
        }, teams: [
            {
                id: faker.string.uuid(),
                label: faker.lorem.word(),
                meeting: faker.string.uuid(),
                color: faker.internet.color(),
                category_id: faker.string.uuid(),
            },
            {
                id: faker.string.uuid(),
                label: faker.lorem.word(),
                meeting: faker.string.uuid(),
                color: faker.internet.color(),
                category_id: faker.string.uuid(),
            },
            {
                id: faker.string.uuid(),
                label: faker.lorem.word(),
                meeting: faker.string.uuid(),
                color: faker.internet.color(),
                category_id: faker.string.uuid(),
            },
            {
                id: faker.string.uuid(),
                label: faker.lorem.word(),
                meeting: faker.string.uuid(),
                color: faker.internet.color(),
                category_id: faker.string.uuid(),
            },
            {
                id: faker.string.uuid(),
                label: faker.lorem.word(),
                meeting: faker.string.uuid(),
                color: faker.internet.color(),
                category_id: faker.string.uuid(),
            },
        ], branche: (_g = params === null || params === void 0 ? void 0 : params.branche) !== null && _g !== void 0 ? _g : BrancheEnum._0, fonction: (_h = user.fonction) !== null && _h !== void 0 ? _h : 'RESPONSABLE D’UNITÉ LOUVETEAUX-JEANNETTES', structure_principale: {
            id: faker.string.uuid(),
            label: '1ère compas Jérusalem',
            structure_code: 'string',
            structure_type: 'string',
            structure_echelon: 'groupe',
        }, num_bafa_bafd: '0123-BAFD', start_interview: 'bien', middle_interview: 'tres bien', end_interview: 'incroyab’', sgdf_opinion: 'sans opinion', js_opinion: 'jeune et fait du sport', food_regime: 'piscivore', canceled: false, gender: '1', phone: '0666666666', email: 'super@genial.tout', avis_prevalidation: 'admise au baccalauréat', avis_validation: 'parfaite', avis_validation_gestionnaire: 'incroyable', avatar_url: `https://xsgames.co/randomusers/avatar.php?g=${user.gender === GenderEnum._1 ? 'male' : 'female'}&uuid=${faker.string.uuid()}`, signature_url: '', avatar_available: true, signature_available: false, observation_count: 0, user_avatar_available: true, user_avatar_url: `https://xsgames.co/randomusers/avatar.php?g=${user.gender === GenderEnum._1 ? 'male' : 'female'}&uuid=${faker.string.uuid()}`, is_bafa_bafd_candidate: faker.datatype.boolean(), tagada_candidate_status: TagadaCandidateStatusEnum.NotSync, tagada_avis_status: TagadaAvisStatusEnum.NotSync, tagada_avis_last_sync: faker.date.past(), tagada_sync_object: "{nom: 'test', prenom: 'test'}", dt_user: createUser(), rg_user: createUser() }, params);
};
//# sourceMappingURL=meeting-participant.js.map